import { Organization } from '../../../login/v1/typings';

export interface WabaItem {
  displayName: string;
}

export const formatWabaNames = (wabas: WabaItem[]): string => {
  if (wabas.length === 1) return wabas[0].displayName;
  if (wabas.length === 2) return `${wabas[0].displayName} and ${wabas[1].displayName}`;
  return `${wabas[0].displayName} +${wabas.length - 1} Channels`;
};

export const isInternalOrg = (currentOrg: Organization | undefined) => {
  const internalOrgIds = [
    'org_EBvT1SNyLW',
    'org_jkVTupA2qo',
    'org_ASdtYuB8fu',
    'org_LApdADolY7',
    'org_I5MwYGoBn8',
    'org_Pe23pfd2H5',
    'org_4VIZBbFh9z',
    'org_fFGD6YFdfP',
    'org_Ttt801d1Mo',
    'org_qzZGN3ryH6',
    'org_XvFstcZvlA',
    'org_QI7gD32bSM',
    'org_IpFJvQgHJs',
    'org_a8njdUhHIE',
    'org_rTyfQuf7Gs',
    'org_vlI7j6cABw',
    'org_8KL35eK87x',
    'org_wQrOyQuKys',
    'org_hcncd863NE',
    'org_gRTMHrvyAA',
    'org_Mz7rXtoC73',
    'org_OGUJoJb8n3',
    'org_CPYsWnyInq',
    'org_r1ziAenHi1',
    'org_QfUH3Fptuq',
    'org_uz3uYfdLtq',
    'org_yMPZi3TJFV',
    'org_R0DOewbbJy',
    'org_qvGOB4LqZX',
    'org_8SL7LpWkXT',
    'org_6PU6UDAVc3',
    'org_9bLy7yOYCU',
    'org_9d5quwXtBe',
    'org_SXmlFNJwJF',
    'org_ARDAwiYfn7',
    'org_6DFlgT8DSg',
    'org_W7XB3pD3fj',
    'org_RqWLaFLHP4',
    'org_ZhJfBemjI7',
    'org_pwTbHCiAtG',
    'org_yNFXCqwdOj',
    'org_hjsz6nF6w5',
    'org_HzqGAJGlNa',
    'org_vHSIB75Ymv',
    'org_7kpbKqzVSv',
    'org_pHKzFuVyyF',
    'org_D1BGq0GeLE',
    'org_w4wEYx0xZ7',
    'org_kartikey00', // 'Citadel' Kartikey's Org
    'org_mitul00000', // 'Hogwarts' Mitul's Org
    'org_shaun00000',
  ];
  return internalOrgIds.includes(currentOrg?.orgId ?? '');
};

export const isTimeWithSecondsEnabledOrgs = (currentOrg: Organization | undefined) => {
  const timeWithSecondsEnabledOrgs = ['org_aO3WOqhv0x'];
  return timeWithSecondsEnabledOrgs.includes(currentOrg?.orgId || '');
};
